import { useRef, useCallback } from "react"
import { LoginForm } from '@/auth/components/login-form'
import { ParticlesBackground, type ParticlesBackgroundRef } from '@/auth/components/particles-background'
import { useDocumentTitle } from '@/shared/hooks/use-document-title'

export default function LoginPage() {
  useDocumentTitle("Login")
  const particlesRef = useRef<ParticlesBackgroundRef | null>(null)

  const handleParticlesReady = useCallback((ref: ParticlesBackgroundRef) => {
    particlesRef.current = ref
  }, [])

  const handleLoginStart = useCallback(() => {
    particlesRef.current?.triggerLoginAnimation()
  }, [])

  const handleLoginError = useCallback(() => {
    particlesRef.current?.resetParticles()
  }, [])

  return (
    <div className="relative flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10 bg-[#121212]">
      <ParticlesBackground onReady={handleParticlesReady} />
      <div className="relative z-10 flex w-full max-w-md flex-col gap-6">
        <LoginForm onLoginStart={handleLoginStart} onLoginError={handleLoginError} />
      </div>
    </div>
  )
}
